import { render, staticRenderFns } from "./BuddhaTypeDetail.vue?vue&type=template&id=a07eb86e&scoped=true"
import script from "./BuddhaTypeDetail.vue?vue&type=script&lang=js"
export * from "./BuddhaTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddhaTypeDetail.vue?vue&type=style&index=0&id=a07eb86e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07eb86e",
  null
  
)

export default component.exports